import { useParams } from "react-router-dom";
import { Link } from "@/components/LLink";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import { useLang } from "@/i18n";
import { LASER } from "@/seo/laserContent";
import { ABKANT } from "@/seo/abkantContent";
import { COATING } from "@/seo/coatingContent";
import { WELDING } from "@/seo/weldingContent";

const DETAIL = {
  "debitare-laser": { id: "laser", content: LASER, hero: "/images/laser-2.jpg", bg: "/images/laser.jpg" },
  "indoire-abkant": { id: "abkant", content: ABKANT, hero: "/images/abkant-2.jpg", bg: "/images/abkant.jpg" },
  "vopsitorie-electrostatica": { id: "coating", content: COATING, hero: "/images/vopsitorie-2.jpg", bg: "/images/vopsitorie.jpg" },
  sudura: { id: "welding", content: WELDING, hero: "/images/sudura-2.jpg", bg: "/images/sudura.jpg" },
};

export default function ServicePage() {
  const { slug } = useParams();
  const { t } = useLang();
  const d = DETAIL[slug];

  if (!d) {
    return (
      <div className="mx-auto max-w-7xl px-4 py-40" data-testid="service-not-found">
        <h1 className="font-heading text-4xl font-black tracking-tighter">{t("notfound")}</h1>
        <Link to="/" className="gold-underline mt-6 inline-block font-mono text-xs uppercase tracking-widest text-acid">{t("back_home")}</Link>
      </div>
    );
  }

  return <ServiceDetailPage key={slug} slug={slug} {...d} />;
}
